import { Component, escapeHtml, register } from './core.js';
import { iconHtml } from './icons.js';
import { cx, pick, mountRoot } from './chrome.js';

const TONES = ['neutral', 'info', 'success', 'warning', 'danger', 'accent'];
const DEFAULTS = { text: '', tone: 'neutral', icon: null, variant: 'soft', size: 'md' };

/** Shared markup builder for Badge (live and static). */
export function badgeHtml(opts) {
	const o = Object.assign({}, DEFAULTS, opts);
	const text = o.text === undefined || o.text === null ? '' : String(o.text);
	if (!text) throw new Error('dfc Badge: text is required; a badge never conveys meaning by colour alone.');
	const cls = cx('dfc', 'dfc-badge', 'dfc-tone-' + pick(o.tone, TONES, 'neutral'), 'dfc-badge-' + pick(o.variant, ['soft', 'outline'], 'soft'), 'dfc-size-' + pick(o.size, ['sm', 'md'], 'md'), o.className);
	return `<span class="${cls}">${iconHtml(o.icon, 'dfc-badge-icon')}<span class="dfc-badge-text">${escapeHtml(text)}</span></span>`;
}

/**
 * Badge: a small inline label. Text is required.
 *
 * new dfc.Badge(container, { text, tone: 'neutral' | 'info' | 'success' | 'warning' | 'danger' | 'accent',
 *   icon, variant: 'soft' | 'outline', size: 'sm' | 'md' })
 * Static: dfc.Badge.renderStatic(opts) -> HTML string
 */
export class Badge extends Component {
	static get componentName() { return 'badge'; }
	defaults() { return Object.assign({}, DEFAULTS); }
	render() { mountRoot(this, badgeHtml(this.options)); }
	static renderStatic(opts = {}) { return badgeHtml(opts); }
}

register('badge', Badge);
